import React from 'react';
import { useTranslation } from 'react-i18next';

const ExpertiseSectionCyberData: React.FC = () => {
  const { t } = useTranslation();
  
  return (
      <div className="expertise-section">
        <div className="main-text">
          <h3 className="h3-gradient">
            {t('dataCyber.expertiseSection.mainText', 'Data Leaks Sentinel offre une veille permanente, une détection des fuites en temps réel et une assistance à la remédiation pour minimiser les dommages et protéger vos informations.')}
          </h3>
        </div>
      </div>
    );
};

export default ExpertiseSectionCyberData;
